// extracted by mini-css-extract-plugin
export default {"root":"_1Wggz","icon":"_2lGPs","text":"d2UwB"};